export default __webpack_public_path__ + "static/media/amandat.e89645a9.jpg";